function toAscii(buf) {
    let s = '';
    for (let i = 0; i < buf.length; i++)
        s += String.fromCharCode(buf[i]);
    return s;
}
function asciiPrintable(buf) {
    return toAscii(buf).replace(/[^\x20-\x7e]/g, '.');
}
export function decodeIdent(identPayload) {
    const ascii = toAscii(identPayload);
    const slice = (start, len) => ascii.slice(start, start + len).replace(/\0+$/, '');
    return {
        hwNumber: slice(0, 7),
        hwIndex: slice(7, 1),
        swNumber: slice(8, 8),
        codingIndex: slice(16, 2),
        diagIndex: slice(18, 2),
        busIndex: slice(20, 4),
        bmwNumber: slice(24, 7),
        variant: slice(31, 2),
        swDate: slice(34, 8),
        raw: asciiPrintable(identPayload),
    };
}
//# sourceMappingURL=identity.js.map